import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import React, { useEffect } from 'react';
import './index.less';

export default () => {
  useEffect(() => {
    // nprogress.configure({
    //   template:
    //     '<div class="bar" role="bar"><div class="peg"><svg class="icon ant-menu-item-icon" aria-hidden="true" style="position:absolute;right:0;height:30px;width:30px"><use xlink:href="#hfs-icon-run-dog"></use></svg></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>',
    // });
    nprogress.start();
    return () => {
      nprogress.done();
    };
  }, []);
  return <React.Fragment />;
};
